module.exports = __webpack_public_path__ + "static/media/hcm-district2.948c9cc1.svg";